import React from 'react';

export interface StoreVersionProps {
  store?: {
    version?: string;
    buildDate?: string;
  };
  api?: {
    version?: string;
    buildDate?: string;
  };
  apiVersion?: string;
  apiBuildDate?: string;
}

export function StoreVersion(props?: StoreVersionProps) {
  return (
    <div className="flex max-h-full w-screen max-w-screen-xl flex-col self-center bg-white p-2 text-right font-sans text-xxs text-mint-medical-grey">
      {props?.store && props.store.version && props.store.buildDate && (
        <span className="font-mono">
          Store Version: {props?.store?.version} | Build: {props?.store?.buildDate}
        </span>
      )}
      {props?.api && props.api.version && props.api.buildDate && (
        <span className="font-mono">
          API Version: {props?.api?.version} | Build: {props?.api?.buildDate}
        </span>
      )}
    </div>
  );
}
